import { ChangeEvent } from 'react';
import { Col, Row } from 'react-bootstrap';
import info from '../../../../assets/images/icons/info.svg';
import FilterRadioButton from '../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../components/FilterRadioButtonsContainer';
import FormGroup from '../../../../components/FormGroup';
import Input from '../../../../components/Input';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import { GetErrorMessageByFieldNameType } from '../../../../hooks/useErrors';
import { ConditionalInputGroup, Container, Group } from '../styles';

interface AffreightmentAccessControlSettingsTabI {
  losesOwnershipWithoutBoarding: boolean;
  daysAllowedWithoutBoarding: number | string;
  handleDaysAllowedWithoutBoardingChange: (event: ChangeEvent<HTMLInputElement>) => void;
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  handleLosesOwnershipWithoutBoardingChange: (losesOwnership: boolean) => void;
  usaHorarioFretado: boolean;
  setUsaHorarioFretado: (value: boolean) => void;
}

export default function AffreightmentAccessControlSettingsTab({
  losesOwnershipWithoutBoarding,
  daysAllowedWithoutBoarding,
  handleDaysAllowedWithoutBoardingChange,
  getErrorMessageByFieldName,
  handleLosesOwnershipWithoutBoardingChange,
  usaHorarioFretado,
  setUsaHorarioFretado,
}: AffreightmentAccessControlSettingsTabI) {
  return (
    <Row xs={1} md={1} lg={1}>
      <Col>
        <Container>
          <div className="card-title">
            Configurações Controle de Acesso - Fretamento
          </div>
          <Group>
            <div className="title">
              <div>
                Usuário perde titularidade sem embarques consecutivos?
                {' '}
                <img src={info} alt="info" title="Habilitar esta opção fará que uma pessoa perca a titularidade caso deixe de embarcar em uma linha com a frequência desejada. Quando ativada, o sistema verificará se o colaborador está deixando de utilizar uma linha de fretamento com a frequência desejada, e irá retirar a titularidade dele na mesma, liberando a vaga para outra pessoa que deseja utilizá-la." />
              </div>
            </div>
            <ConditionalInputGroup>
              <FilterRadioButtonsContainer notOverflow>
                <FilterRadioButton
                  selected={losesOwnershipWithoutBoarding}
                  onClick={() => handleLosesOwnershipWithoutBoardingChange(true)}
                >
                  Sim
                </FilterRadioButton>
                <FilterRadioButton
                  selected={!losesOwnershipWithoutBoarding}
                  onClick={() => handleLosesOwnershipWithoutBoardingChange(false)}
                >
                  Não
                </FilterRadioButton>
              </FilterRadioButtonsContainer>

              {losesOwnershipWithoutBoarding && (
                <OpacityAnimation>
                  <FormGroup error={getErrorMessageByFieldName('daysAllowedWithoutBoarding')}>
                    <label htmlFor="daysOfHolder">Tolerância de dias sem embarcar</label>
                    <Input
                      value={daysAllowedWithoutBoarding}
                      onChange={handleDaysAllowedWithoutBoardingChange}
                      error={getErrorMessageByFieldName('daysAllowedWithoutBoarding')}
                      placeholder='Informe a quantidade de dias'
                      maxLength={2}
                    />
                  </FormGroup>
                </OpacityAnimation>
              )}
            </ConditionalInputGroup>
          </Group>

          <Group>
            <div className="title">
              <div>
                Utilizar diferenciação de linhas por horário no fretamento?
                {' '}
                <img src={info} alt="info" title="Quando ativada, o sistema verifica se a empresa possui linhas de fretamento disponíveis conforme o horário e local de trabalho do colaborador. Quando desativada, todas as linhas são enviadas no bias caso não haja correspondência." />
              </div>
            </div>
            <ConditionalInputGroup>
              <FilterRadioButtonsContainer notOverflow>
                <FilterRadioButton
                  selected={usaHorarioFretado}
                  onClick={() => setUsaHorarioFretado(true)}
                >
                  Sim
                </FilterRadioButton>
                <FilterRadioButton
                  selected={!usaHorarioFretado}
                  onClick={() => setUsaHorarioFretado(false)}
                >
                  Não
                </FilterRadioButton>
              </FilterRadioButtonsContainer>
              <OpacityAnimation>
                <small style={{ display: 'block', marginTop: '8px', color: '#666' }}>
                  {usaHorarioFretado
                    ? 'Verifica se a empresa tem linhas de fretamento disponíveis conforme o horário e local de trabalho do colaborador. Se não tiver linha correspondente, NÃO ENVIA FRETAMENTO no bias.'
                    : 'Não efetua verificação de linhas de fretado por horário da linha. Sempre envia todas as linhas no bias caso não encontre correspondência.'}
                </small>
              </OpacityAnimation>
            </ConditionalInputGroup>
          </Group>
        </Container>
      </Col>
    </Row>
  );
}
